import { ShieldCheck } from "lucide-react";
import type { MailProviderPreset } from "@/lib/types/mail";

type Props = {
  provider: MailProviderPreset | null;
};

export function OAuthHintBanner({ provider }: Props) {
  const isGmailOAuth = provider?.id === "gmail" && provider.oauthAvailable === true;
  const isMicrosoftOAuth = provider?.id === "microsoft" && provider.oauthAvailable === true;
  const isOAuth = isGmailOAuth || isMicrosoftOAuth;

  return (
    <div className="space-y-2">
      <div className="mail-form-info-box flex gap-2 px-3 py-2.5" role="note">
        <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0 text-[var(--mail-accent)]" aria-hidden />
        <p>
          {isGmailOAuth ? (
            <>
              <strong>Gmail</strong> — connectez-vous avec Google.
            </>
          ) : isMicrosoftOAuth ? (
            <>
              <strong>Microsoft</strong> — connectez-vous avec Microsoft.
            </>
          ) : (
            <>
              Aurélia Mail se connecte en <strong>IMAP/SMTP</strong> avec votre e-mail et mot de passe
              {provider?.modernAuth ? " (ou mot de passe d'application)." : "."}
            </>
          )}
        </p>
      </div>

      {provider?.modernAuth && !isOAuth ? (
        <div className="mail-form-warn-box px-3 py-2" role="note">
          <strong>{provider.label}</strong> — créez un{" "}
          <strong>mot de passe d&apos;application</strong> dans les paramètres de sécurité du compte
          (2FA requis).
          {provider.hint ? <span className="mt-1 block opacity-90">{provider.hint}</span> : null}
        </div>
      ) : null}
    </div>
  );
}
